import { faker } from '@faker-js/faker';
import {
  articleId,
  genericId,
  packageId,
  tenantId,
} from '@cnx-saas/utils-cnx-id';
import {
  Article,
  ArticleInput,
  ArticlePackaging,
  Package,
  Packaging,
} from '../types';

export const fakeArticleFactory = {
  createArticleInput: (data?: Partial<ArticleInput>): ArticleInput => {
    return {
      externalReference: genericId(),
      name: faker.commerce.productName(),
      weightInKgPerUnit: faker.datatype.number({ min: 1, max: 100 }),
      packagingOptions: [{ packagingCode: genericId(), articlesPerPackage: 5 }],
      ...data,
    };
  },

  createArticle: (
    data?: Partial<ArticleInput>,
    packagingOptions?: ArticlePackaging[],
  ): Article => {
    return {
      id: articleId(),
      tenantId: tenantId(),
      createdAt: faker.date.past(),
      updatedAt: faker.date.recent(),
      ...fakeArticleFactory.createArticleInput(),
      ...data,
      packagingOptions: packagingOptions || [
        {
          articlesPerPackage: 5,
          maxStackSize: 1,
          packaging: fakeArticleFactory.createPackaging(),
        },
      ],
    };
  },

  createArticleUnit: (data?: Partial<Packaging>): Packaging => {
    return {
      ...fakeArticleFactory.createPackaging(data),
      ...data,
    };
  },

  createPackaging: (data?: Partial<Packaging>): Package => {
    return {
      id: packageId(),
      tenantId: tenantId(),
      packagingCode: genericId(),
      packagingDescription: faker.commerce.productMaterial(),
      articlesPerPackage: faker.datatype.number({ min: 1, max: 1000 }),
      maxStackSize: faker.datatype.number({ min: 1, max: 100 }),
      dimensions: {
        weight: faker.datatype.number({ min: 1, max: 100 }),
        height: 1000,
        width: 1000,
        length: 1000,
      },
      ...data,
      // parent: data?.parent || {
      //   packaging: fakeArticleFactory.createPackaging(),
      //   quantityChildrenPerParent: faker.datatype.number({ min: 1, max: 10 }),
      // },
    };
  },
};
